import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FcPaginatorComponent } from '@core/components/fc-paginator/fc-paginator.component';
import { chunk } from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { GroupService } from '../../../../services/groups-api.service';
var LinkLocationsComponent = /** @class */ (function () {
    function LinkLocationsComponent(data, dialogRef, groupService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.groupService = groupService;
        this.page = null;
        this.searchInput = new FormControl();
        this.isLoading = true;
        this.isSaving = false;
        this.isAllSelected = false;
        this.currentPage = 0;
        this.pageSize = 5;
        this.isPageChanging = false;
        this.locationToAdd = new Map();
        this.linkAllLocations = false;
        this.reload = new Subject();
        this.removeSubscriptions = new Subject();
        this.group = data.group;
    }
    LinkLocationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.searchInput.valueChanges.pipe(debounceTime(500)).subscribe(function () {
            _this.isLoading = true;
            if (_this.paginator) {
                _this.paginator.firstPage();
            }
            else {
                _this.reload.next();
            }
        });
        this.reload.pipe(takeUntil(this.removeSubscriptions), tap(function () { return _this.isLoading = true; }), switchMap(function () { return _this.searchLocations(); }), tap(function () {
            _this.isLoading = false;
        })).subscribe(function (page) {
            _this.page = page;
            _this.form.nativeElement.scrollTo({ top: 0 });
        });
        this.reload.next();
    };
    LinkLocationsComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    LinkLocationsComponent.prototype.toggleLocationLinkedToGroup = function (checked, location) {
        if (this.linkAllLocations) {
            this.linkAllLocations = false;
            if (this.locationToAdd.has(location.id)) {
                this.locationToAdd.delete(location.id);
            }
            else {
                this.locationToAdd.set(location.id, checked);
            }
            this.isAllSelected = this.checkIfIsAllSelected();
            return;
        }
        if (this.locationToAdd.has(location.id)) {
            this.locationToAdd.delete(location.id);
        }
        else {
            this.locationToAdd.set(location.id, checked);
        }
        this.isAllSelected = this.checkIfIsAllSelected();
    };
    LinkLocationsComponent.prototype.searchLocations = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.groupService.listLocations({
                        groupId: this.group.id,
                        limit: this.pageSize,
                        offset: this.currentPage * this.pageSize,
                        where: {
                            formattedAddressOrDocumentNumber_contains: this.searchInput.value || '',
                        }
                    })];
            });
        });
    };
    LinkLocationsComponent.prototype.toggleAllSelected = function (checked) {
        var e_1, _a;
        var locations = (this.page && this.page.items) || [];
        try {
            for (var locations_1 = tslib_1.__values(locations), locations_1_1 = locations_1.next(); !locations_1_1.done; locations_1_1 = locations_1.next()) {
                var location_1 = locations_1_1.value;
                if (!location_1.groupsConnection.items.length) {
                    this.toggleLocationLinkedToGroup(checked, location_1);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (locations_1_1 && !locations_1_1.done && (_a = locations_1.return)) _a.call(locations_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.isAllSelected = this.checkIfIsAllSelected();
    };
    LinkLocationsComponent.prototype.checkIfIsAllSelected = function () {
        var _this = this;
        var locations = (this.page && this.page.items) || [];
        return locations.length && locations.every(function (location) { return location.groupsConnection.items.length || _this.locationToAdd.has(location.id); });
    };
    LinkLocationsComponent.prototype.continue = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var keys, _a, _b, locationIds, e_2_1;
            var e_2, _c;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.isSaving = true;
                        if (!this.linkAllLocations) return [3 /*break*/, 2];
                        this.isLoading = true;
                        return [4 /*yield*/, this.groupService.linkAllLocationsToGroup({ groupId: this.group.id })];
                    case 1:
                        _d.sent();
                        this.isSaving = false;
                        this.dialogRef.close({
                            reload: true
                        });
                        return [2 /*return*/];
                    case 2:
                        keys = Array.from(this.locationToAdd.keys());
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 8, 9, 10]);
                        _a = tslib_1.__values(chunk(keys, 100)), _b = _a.next();
                        _d.label = 4;
                    case 4:
                        if (!!_b.done) return [3 /*break*/, 7];
                        locationIds = _b.value;
                        return [4 /*yield*/, this.groupService.addLocationToGroup(locationIds.map(function (locationId) { return ({
                                locationId: locationId,
                                groupId: _this.group.id
                            }); }))];
                    case 5:
                        _d.sent();
                        _d.label = 6;
                    case 6:
                        _b = _a.next();
                        return [3 /*break*/, 4];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_2_1 = _d.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 10:
                        this.isSaving = false;
                        this.dialogRef.close({
                            reload: true
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    LinkLocationsComponent.prototype.onPageChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isPageChanging = true;
                        this.currentPage = event.pageIndex;
                        _a = this;
                        return [4 /*yield*/, this.searchLocations()];
                    case 1:
                        _a.page = _b.sent();
                        this.isAllSelected = this.checkIfIsAllSelected();
                        this.form.nativeElement.scrollTo({ top: 0 });
                        this.isPageChanging = false;
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    LinkLocationsComponent.prototype.selectAllLocations = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.linkAllLocations = true;
                return [2 /*return*/];
            });
        });
    };
    return LinkLocationsComponent;
}());
export { LinkLocationsComponent };
